
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payments/plans/premium-features",
      function () {
        return require("private-next-pages/payments/plans/premium-features/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payments/plans/premium-features"])
      });
    }
  